(() => {
  class VenroDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      clearInterval(this.timer);
      this.abort = new AbortController();
      try {
        this.variants = JSON.parse(this.querySelector('[data-delivery-variants]')?.textContent || '{}');
      } catch {
        this.variants = {};
      }
      this.root = this.closest('venro-customizer,venro-coaster-customizer,venro-wheel-customizer,venro-holiday-customizer') || this.closest('section') || document;
      this.refresh = () => {
        const id = this.root.querySelector('[name="id"]')?.value || this.dataset.variant;
        const variant = this.variants[id];
        this.setOrigin(typeof variant === 'object' && variant ? variant.origin || variant.country : variant || this.dataset.origin);
      };
      this.root.addEventListener('change', () => queueMicrotask(this.refresh), { signal: this.abort.signal });
      this.root.addEventListener('venro:variant-change', this.refresh, { signal: this.abort.signal });
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.timer);
    }
    setOrigin(origin) {
      const valid = origin === 'US' || origin === 'CN';
      this.dataset.currentOrigin = valid ? origin : '';
      const output = this.querySelector('[data-delivery-date]');
      if (!output) return;
      output.hidden = !valid;
      if (!valid) {
        output.textContent = '';
        return;
      }
      const now = new Date();
      const day = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 12);
      const [min, max] = origin === 'US' ? [5, 10] : [10, 17];
      const start = new Date(day + min * 86400000);
      const end = new Date(day + max * 86400000);
      const options = { month: 'long', day: 'numeric', timeZone: 'UTC' };
      if (start.getUTCFullYear() !== now.getFullYear() || end.getUTCFullYear() !== now.getFullYear()) options.year = 'numeric';
      const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en', options);
      output.textContent = format.formatRange(start, end).replace(/\s*[–—]\s*/g, ' – ').replace(/[.。]$/, '');
    }
  }
  if (!customElements.get('venro-delivery-estimate')) customElements.define('venro-delivery-estimate', VenroDeliveryEstimate);
})();
